import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';
import EditButton from '../../../common/button/EditButton';
import { EXCHANGE_RATE_PATH } from '../../../../config/paths';
import ExhcangeRateDeleteButton from './ExchangeRateDeleteButton';

const ExhcangeRateToolbar = ({ exchangeRateId }) => (
  <ButtonToolbar className="pull-right">
    <div>
      <EditButton path={`${EXCHANGE_RATE_PATH}/${exchangeRateId}/edit`} />{' '}
      <ExhcangeRateDeleteButton exchangeRateId={exchangeRateId} />
    </div>
  </ButtonToolbar>
);

ExhcangeRateToolbar.propTypes = {
  exchangeRateId: PropTypes.number.isRequired,
};

export default ExhcangeRateToolbar;
